import fp from 'lodash/fp';
import { connect } from 'react-redux';
import container from 'src/ServiceContainer';
import { ASSORTMENT } from 'src/utils/Domain/Constants';
import { makePrintSensitive } from 'src/components/higherOrder/Print/PrintSenstive';
import { overloadSubheader } from 'src/components/Subheader/Subheader.slice';
import {
  cleanUp,
  receiveError,
  requestPricingOverTimeConfig,
  receivePricingOverTimeConfig,
  submitPayload,
  receivePricingEvents,
  fetchMassEditData,
  fetchCompanionData,
  updateSelectedItem,
  receiveSomePricingOverTimeConfig,
  refreshOvertimeData,
} from './PricingOverTime.slice';
import { AppState, AppThunkDispatch } from 'src/store';
import { projectState } from 'src/components/ListGridPair/ListGridPair.selectors';
import { PricingOverTime } from 'src/pages/AssortmentBuild/Pricing/PricingOverTime';
import Axios from 'src/services/axios';
import { isEmpty, isNil } from 'lodash/fp';
import { makePopoverSensitive } from 'src/components/AssortmentStyleDetailsPopover/AssortmentStyleDetailsPopover';
import { MassEditConfig } from 'src/components/MassEdit/MassEdit';
import { TenantConfigViewData } from 'src/dao/tenantConfigClient';
import { get } from 'lodash';
import { FabType, getfabProps, withFab } from 'src/components/higherOrder/withFab';
import { updateAssortmentPlan } from 'src/pages/AssortmentBuild/StyleEdit/StyleEdit.actions';
import { OwnProps, PricingEventResponse } from './PricingOverTime.types';
import { isDataLoaded } from 'src/services/pivotServiceCache';
import { ViewDataState } from 'src/types/Domain';
import { ComponentErrorType } from 'src/components/ErrorBoundary/ErrorBoundary.slice';
import { ConfDefnComponentType } from 'configuration-schemas/confdefnComponents';
import { AdornmentType } from 'configuration-schemas/viewdefns/literals';
import { zGridViewDefn, zMassEditDefn } from 'configuration-schemas/viewdefns/viewdefn';
import {
  zCompanionViewDefn,
  zGroupByConfig,
  zRollupDefn,
  zSortByConfig,
} from 'configuration-schemas/viewdefns/general';
import { getLocalConfig } from 'src/components/ViewConfiguratorModal/ViewConfiguratorModal.utils';
import { GranularEditPayloadItem } from 'src/dao/pivotClient';
import { FlowSheetAndPricingDispatchProps, FlowSheetAndPricingMapState } from '../FlowSheet/FlowSheet.types';
import { bindActionCreators } from '@reduxjs/toolkit';
import { toggleCompanionCollapse } from 'src/state/uipose/UiPose.slice';
import {
  selectPricingHasMassEditViewDefn,
  selectPricingHasMassEditModel,
  selectPricingMassEditDataLoaded,
  selectPricingViewDataStates,
  selectPricingCompanionData,
  selectPricingOverTimeData,
} from './PricingOverTime.selectors';

export function dispatchToProps(dispatch: AppThunkDispatch, ownProps: OwnProps): FlowSheetAndPricingDispatchProps {
  const { tenantConfigClient } = container;
  const { defns } = ownProps;
  const [modelDefn, massEditModelDefn] = defns.models;

  return {
    ...bindActionCreators({ onToggleCompanion: toggleCompanionCollapse }, dispatch),
    submitPayload(payload: GranularEditPayloadItem[], shouldRefresh = true) {
      return dispatch(submitPayload(payload, shouldRefresh));
    },
    onCompanionItemClick(memberId: string) {
      dispatch(updateSelectedItem(memberId));
    },
    onShowView() {
      let hasMassEdit = false;
      Promise.all([
        Axios.get<PricingEventResponse>(`/api/v2/events?appName=${ASSORTMENT}`),
        tenantConfigClient.getTenantViewDefnsWithFavorites({
          defnIds: defns.view,
          appName: ASSORTMENT,
          validationSchemas: [
            zGridViewDefn,
            zSortByConfig,
            zGroupByConfig,
            zRollupDefn,
            zCompanionViewDefn,
            zMassEditDefn,
          ],
        }),
        dispatch(requestPricingOverTimeConfig()),
      ])
        .then((resp) => {
          const [eventsResp, viewConfig] = resp;
          dispatch(receivePricingEvents(eventsResp.data.data));

          const defnStr = defns.view[0];
          const favoritesList = (viewConfig as any)[defns.view.length];
          const unmodifiedViewDefn = viewConfig[0];
          const listConfig = viewConfig[4];
          const localConfig = getLocalConfig(defnStr, favoritesList, dispatch, unmodifiedViewDefn);

          hasMassEdit = !isNil(viewConfig[5]);
          const massEditModel = defns.models[1];
          const hasMassEditModel = selectPricingHasMassEditModel({} as AppState, massEditModel);
          const hasMassEditViewDefnConfigured = selectPricingHasMassEditViewDefn({} as AppState, defns);
          const massEditConfig = viewConfig[5];
          const massEdit = hasMassEditViewDefnConfigured
            ? (massEditConfig as unknown as MassEditConfig) // FIXME: revisit this type issue
            : undefined;

          dispatch(
            receivePricingOverTimeConfig({
              grid: localConfig?.config || unmodifiedViewDefn,
              listSort: viewConfig[1],
              subheaderRollUp: viewConfig[3],
              list: listConfig,
              listLevelBy: viewConfig[6],
              massEdit,
              unmodifiedViewDefn,
            }),
          );
          dispatch(
            overloadSubheader({
              groupByOptions: viewConfig[2],
              showFlowStatus: true,
              showSearch: true,
              title: 'Grid View',
            }),
          );

          if (ownProps.hideCompanion) {
            dispatch(refreshOvertimeData());
          } else {
            if (hasMassEditModel) {
              dispatch(fetchMassEditData(massEditModel));
            }
            const companionModel = listConfig.model ? listConfig.model : modelDefn;
            dispatch(fetchCompanionData(companionModel));
          }
        })
        .catch((error) =>
          dispatch(
            receiveError({
              type: ComponentErrorType.config,
              message: (error as Error)?.message,
              name: ConfDefnComponentType.pricing,
              stack: (error as Error)?.stack,
              issues: error,
              defnId: error.defnId,
            }),
          ),
        )
        .finally(() => {
          if (hasMassEdit && massEditModelDefn) {
            dispatch(fetchMassEditData(massEditModelDefn));
          }
        });
    },
    onUpdateConfig(config: TenantConfigViewData) {
      dispatch(receiveSomePricingOverTimeConfig(config));
    },
    onDestroy() {
      dispatch(cleanUp());
    },
    updateAssortmentPlan: () => {
      dispatch(updateAssortmentPlan('PlanQueue'));
    },
  };
}

export function mapStateToProps(state: AppState, ownProps: OwnProps): FlowSheetAndPricingMapState {
  const viewState = state.pages.assortmentBuild.pricing;
  const {
    title,
    defns,
    keys,
    showPopover,
    fabType = FabType.none,
    showFlowStatus,
    showUndoBtn,
    hideCompanion,
    subheaderErrorText,
  } = ownProps;
  const { rangeList, daysRangeList, timeInfo } = state.scope;
  const allowFrom = !isEmpty(rangeList) ? rangeList[0].id : '';
  const allowTo = !isEmpty(rangeList) ? rangeList[rangeList.length - 1].id : '';
  const fabProps = getfabProps(state, fabType);

  const companionData = selectPricingCompanionData(state);
  const overTimeData = selectPricingOverTimeData(state);
  const companionDataLoaded = isDataLoaded(viewState.viewDataStateCompanion);
  const overTimeDataLoaded = isDataLoaded(viewState.viewDataStateOverTime);
  const massEditModel = defns.models[1];
  const massEditDataLoaded = selectPricingMassEditDataLoaded(state, { defns, massEditModel });
  const liveDataReady = viewState.viewDataStateOverTime === ViewDataState.liveDataReady;
  const adornments: AdornmentType[] = get(viewState.viewDefns, 'grid.adornments', []);
  const selectedId = viewState.selectedItem;
  const rowHeight = viewState.viewDefns.grid.main?.rowHeight;
  const groupRowHeight = viewState.viewDefns.grid.main?.groupRowHeight;
  const columnWidth = viewState.viewDefns.grid.main?.columnWidth;
  const configLoaded = !viewState.isConfigLoading;
  const dataLoaded = companionDataLoaded;
  const scopeStart: string | null = get(state, 'scope.scope.start');
  const itemLocation = state.scope.scope.locationMember!;
  const viewDataStates = selectPricingViewDataStates(state, defns);
  const originalState = {
    title,
    identityField: keys.idProp,
    treeData: companionData,
    subheaderState: state.subheader,
    subheaderViewDefns: defns.subheader,
    shouldFilterFlowStatus: true,
    allowFrom,
    allowTo,
    rangeList: daysRangeList,
    showPopover,
    activeTab: state.perspective.activeTab,
    ...viewState,
    timeInfo,
    showFlowStatus: showFlowStatus === false ? false : true,
    adornments,
    selectedId,
    rowHeight,
    groupRowHeight,
    columnWidth,
    configLoaded,
    dataLoaded,
    showUndoBtn,
    allowWorklistFunctionality: false,
    fab: fabProps,
    isCompanionCollapsed: state.uiPose.isCompanionCollapsed,
    hideCompanion,
    subheaderErrorText,
    viewDataStates,
  };

  const stateProps = {
    ...originalState,
    ...projectState(originalState),
    ...viewState,
    scopeStart,
    overTimeDataLoaded,
    massEditDataLoaded,
    liveDataReady,
    overTimeData,
    itemLocation,
  };
  return stateProps;
}

function mergeProps(stateProps: FlowSheetAndPricingMapState, dispatchProps: FlowSheetAndPricingDispatchProps) {
  return {
    ...stateProps,
    ...dispatchProps,
  };
}
const sensitiveView = fp.flow(() => PricingOverTime, withFab, makePrintSensitive, makePopoverSensitive)();

export default connect(mapStateToProps, dispatchToProps, mergeProps)(sensitiveView);
